<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Benutzer erstellen
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-stepper v-model="createUserStepper" alt-labels class="createUserStepper">
        <v-stepper-header>
          <v-stepper-step
              :complete="createUserStepper > 1"
              step="1"
          >
            <span>Rolle festelegen</span>
          </v-stepper-step>
          <v-stepper-step
              :complete="createUserStepper > 2"
              step="2"
          >
            <span>Markt auswählen</span>
          </v-stepper-step>

          <v-divider/>

          <v-stepper-step
              :complete="createUserStepper > 3"
              step="3"
          >
            <span>Userdaten eingeben</span>
          </v-stepper-step>

          <v-divider/>

          <v-stepper-step
              :complete="createUserStepper > 4"
              step="4"
          >
            <span>Überprüfen</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
              step="5">
            Nutzer angelegt
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="createUserStepper">
          <v-stepper-content step="1">
            <v-card class="createUserNameCard" elevation="0">
              <span>Rolle angeben</span>
              <v-chip-group v-model="role" class="chip-group__role-selection" light>
                <v-chip value="3">
                  Admin
                </v-chip>
                <v-chip value="1">
                  Kunde
                </v-chip>
                <v-chip value="2">
                  Leergut
                </v-chip>
              </v-chip-group>
              <v-btn
                  @click="proceedRoleSelection()"
                  class="marketSelectBtn"
                  :disabled="role===null"
              >
                <span>Weiter</span>
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="stepperSearchWrapper">
              <v-container class="stepperSearchContainer">
                <span>Kundenauswahl</span>

                <v-text-field class="searchCbx"
                              append-icon=""
                              outlined
                              dense
                              v-model="marketSearchCbx"
                              hide-details
                              placeholder="Kundenname..."
                >

                  <template v-slot:prepend>
                    <magnifyGlass_small/>
                  </template>
                  <template v-slot:append v-if="loadingResults">
                    <v-progress-circular indeterminate class="searchProgressCircular"/>
                  </template>
                </v-text-field>
              </v-container>
            </v-card>
            <v-row v-if="!loadingResults" :key="marketsFiltered">
              <v-col cols="12"
                     v-for="market in markets"
                     :key="market.customerNo"
              >
                <v-card class="marketWrapper">
                  <v-container>
                    <span class="marketName">{{ market.marketName }}</span>
                    <br>
                    <span class="customerId">Kundennummer: {{ market.customerNo }}</span>
                    <br>

                    <span class="address">
                        {{ market.address }}
                        <br>
                        {{ market.city }}
                      </span>
                    <v-btn class="marketSelectBtn"
                           @click="selectMarket(market.customerNo, market.marketName)"
                    >
                      Auswählen
                    </v-btn>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="createUserNameCard" elevation="0">
              <span>Name</span>
              <v-form class="createUserNameForm">
                <v-text-field
                    class="nameTxtField"
                    rounded
                    v-model="firstname"
                    outlined
                    dense
                    placeholder="Vorname..."
                ></v-text-field>

                <v-text-field
                    class="nameTxtField"
                    rounded
                    v-model="lastname"
                    outlined
                    dense
                    placeholder="Nachname..."
                ></v-text-field>
              </v-form>
              <v-btn
                  @click="createUser"
                  class="marketSelectBtn"
                  :disabled="role===null || firstname === '' || lastname === ''"
              >
                <span>Benutzer anlegen</span>
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="articleCard" elevation="0">
              <v-container>
                <v-row>
                  <v-col cols="12">
                      <span>
                        Benutzer für Kunde: {{ activeMarket }}
                        <br>
                        {{ activeMarketName }}
                        <br>
                        wurde erstellt.
                        <br>
                        Die ID lautet: {{ userId }}
                      </span>
                  </v-col>
                </v-row>

                <v-card-actions>

                </v-card-actions>
              </v-container>
              <v-btn
                  @click="proceed"
                  class="marketSelectBtn"
              >
                <span>zurück zur Startseite</span>
              </v-btn>

            </v-card>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import axios from "axios";
import router from "@/router";
import magnifyGlass_small from "@/assets/magnifyGlass_small";
export default {
  name: "createUser",
  components: {magnifyGlass_small},
  data:() => {
    return {
      createUserStepper: 1,

      marketSearchCbx: '',
      marketSearch: null,
      marketResults : [],
      loadingResults: false,
      marketsFiltered: false,
      activeMarket: null,
      activeMarketName: null,

      firstname: '',
      lastname: '',
      userId: '',

      customerNo: '',
      role: null,

      isLoading: true
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      if(this.createUserStepper > 1) {
        this.createUserStepper -= 1;
      }

      else {
        router.go(-1)
      }
    },

    searchMarkets(val) {
      if(val.length === 3 && this.marketResults.length === 0) {
        this.loadingResults = true

        const params = {
          searchTerm: val
        }

        axios.post('/api/searchCustomer', params)
            .then((result) => {
              this.marketResults = result.data
            })
            .finally(() =>{
              this.loadingResults = false
              if(this.marketResults.length > 0) {
                this.searchActive = true
              }
            })
      }

      else if(val.length < 3) {
        this.marketResults = []
        this.searchActive = false
        this.loadingResults = false
        this.activeMarket = null
      }

    },

    selectMarket(marketNr, marketName) {
      this.activeMarket = marketNr
      this.activeMarketName = marketName
      this.createUserStepper += 1
    },

    proceedRoleSelection() {
      if(this.role === '2') {
        this.createUserStepper = 3
      }
      else {
        this.createUserStepper = 2
      }
    },

    createUser() {
      return new Promise(() => {
        const params = {
          firstname: this.firstname,
          lastname: this.lastname,
          role: this.role,
          customerNo: this.activeMarket
        }

        axios.post('/api/createUser', params)
            .then((response) => {
              this.userId = response.data
              this.createUserStepper += 1
            })
      })
    },

    proceed() {
      router.push({name: 'LastArticle'})
      this.createUserStepper = 1
    }
  },

  created() {
    this.setHeaderVisibility(false)
  },

  watch: {
    marketSearchCbx() {
      this.searchMarkets(this.marketSearchCbx)
    },
  },

  computed: {
    markets()  {
      const searchVal = this.marketSearchCbx.toLowerCase().trim()
      if (this.marketResults.length > 0 && this.marketSearchCbx.length > 3) {
        return this.marketResults.filter(val =>
            (val.city ? val.city : '').toLowerCase().indexOf(searchVal) > -1 ||
            (val.address ? val.address : '').toLowerCase().indexOf(searchVal) > -1 ||
            (val.customerNo ? val.customerNo : '').toString().indexOf(searchVal) > -1 ||
            (val.marketName ? val.marketName : '').toLowerCase().indexOf(searchVal) > -1
        )
      }
      else {
        return this.marketResults
      }
    },
  }
}
</script>

<style>
.createUserStepper {
  box-shadow: none;
  overflow: visible;
}

.createUserStepper .v-stepper__wrapper {
  overflow: visible;
}

.createUserStepper.theme--light.v-stepper {
  background-color: transparent;
}

.createUserStepper .v-stepper__header {
  display: none;
}

.createUserStepper .articleCard {
  overflow: visible;
}

.stepperSearchContainer {
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
}

.stepperSearchContainer span:first-child {
  margin-right: auto;
  font-size: 16px;
  margin-bottom: 20px;
}

.searchCbx .v-text-field__slot{
  font-size: 14px;
}

.searchCbx .v-input__slot {
  border-radius: 30px;
  padding-left: 20px!important;
  padding-right: 20px!important;
}

.marketWrapper .container {
  padding: 15px 30px;
  line-height: 2;
}

.marketName {
  font-size: 16px;
  margin-right: auto;
  display: inline-block;
}

.customerId {
  font-size: 14px;
  color: var(--igros-red);
  margin-right: auto;
  display: inline-block;
}

.address {
  font-size: 14px;
  color: var(--igros-charcoal);
  margin-right: auto;
  display: inline-block;
  line-height: 1;
}

.marketSelectBtn {
  margin-left: auto;
  position: absolute;
  bottom: -20px;
  right: 30px;
}

.marketSelectBtn.theme--light.v-btn {
  min-height: 20px;
}

.createUserStepper .col{
  padding-top: 0px;
  padding-bottom: 0px;
}

.createUserStepper .col:first-child{
  margin-bottom: 16px;
}

.createUserStepper .col:last-child{
  margin-top: 16px;
  margin-bottom: 25px;
}

.createUserStepper .col:not(:first-child):not(:last-child) {
  margin: 16px 0px;
}

.createUserNameCard {
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
}

.createUserNameCard span {
  margin-right: auto;
}

.createUserNameCard .container {
  padding-left: 0px;
  padding-right: 0px;
  overflow: visible;
}

.nameTxtField .v-text-field__slot{
  font-size: 14px;
}

.createUserNameForm {
  padding-top: 15px;
  padding-bottom: 40px;
}

.createUserNameCard .nameTxtField:last-child {
  margin-top: 15px;
}

.marketSelectBtn.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: lightgrey!important;
}

.chip-group__role-selection .v-slide-item--active {
  background-color: var(--igros-red) !important;
}

.chip-group__role-selection {
  margin-bottom: 20px;
}

.chip-group__role-selection .theme--light.v-chip--active:hover::before, .theme--light.v-chip--active::before {
  opacity: 0;
}

</style>
